module.exports = __webpack_public_path__ + "img/top-beijing.8c97f695.png";